import api from "./api.ts";

export async function cancelSubscription() {
  const token = localStorage.getItem("token");
  return api.post(
    "/subscription/cancel",
    {},
    { headers: token ? { Authorization: `Bearer ${token}` } : {} }
  );
}
